import { cva } from "class-variance-authority";

export const rootStyles = cva("relative flex justify-center [&>svg]:w-full", {
  variants: {
    size: {
      sm: "w-38",
      md: "w-43",
      lg: "w-55",
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

export const illustrationIconStyle = cva("absolute", {
  variants: {
    size: {
      sm: "bottom-6",
      md: "bottom-2",
      lg: "bottom-4",
    },
    color: {
      primary: "bg-primary-60 text-white",
      gray: "bg-[#344054]/40 text-white",
    },
  },
  defaultVariants: {
    color: "primary",
    size: "sm",
  },
});
